// 部门相关API接口
import request from '@/utils/request'
// 向外按需导出一个API函数
/**
 * 获取部门树形结构
 * 部门服务树形展示
 * 树形展示用户指定服务可查询的部门，供其他页面指定部门范围时使用
 * @param serviceCode如果不传后台默认SYS-USER
 * 如果BUSINESS-PROJECT
 * @returns {*}
 */
export function departmentTree(params) {
    return request({
        url: '/department/tree',
        method: 'get',
        params
    })
}

/**
 * 部门设置树形展示
 * 树形展示用户可查询的部门
 * @returns {*}
 */
export function departmentSelfTree() {
    return request({
        url: '/department/self/tree',
        method: 'get'
    })
}
/**
 * 分页获取部门列表
 * @param data
 * @returns {*}
 */
export function departmentPage(params,data) {
    return request({
        url: '/department/page',
        method: 'post',
        data,
        params
    })
}
/**
 *添加部门
 * @param data
 * @returns {*}
 */
export function addDepartment(data) {
    return request({
        url: '/department',
        method: 'post',
        data
    })
}

/**
 * 删除部门
 * @returns {*}
 */
export function delDepartment(data) {
    return request({
        url: '/department',
        method: 'delete',
        data
    })
}

/**
 * 修改部门
 * @param data
 * @returns {*}
 */
export function updateDepartment(data) {
    return request({
        url: '/department',
        method: 'put',
        data
    })
}
/**
 * 检查部门是否存在
 * @param data
 * @returns {*}
 */
export function existDepartment(data) {
    return request({
        url: '/department/exist',
        method: 'post',
        data
    })
}
